
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 27","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.998 25.541c6.627 0 11.998-5.372 11.998-11.998 0-6.627-5.371-11.998-11.998-11.998C6.372 1.545 1 6.916 1 13.543 1 20.169 6.372 25.54 12.998 25.54z","stroke":"#E6E7E9","stroke-width":"1.846","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.923 20.004l3.691-11.076L6.54 12.62l4.615 2.769 2.769 4.615z","stroke":"#E6E7E9","stroke-width":"1.846","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    